import { ElementRef, ViewContainerRef, Directive } from '@angular/core';

@Directive({
   selector: '[cell-holder]'
})
export class CellHolderDirective {
   constructor(
      public hostRef: ElementRef<HTMLElement>,
      public viewContainerRef: ViewContainerRef
   ) { }
}
